"use client";

export enum SignatureAlgorithmName {
  ECDSA = "ecdsa",
  ED25519 = "ed25519",
  BIP340 = "bip340",
}

type WalletID = string;
type Xpub = string;

// algo-walletId - eg. ecdsa-1234
type StytchWalletKey = `${SignatureAlgorithmName}:${WalletID}`;

export type StytchBackupData = Record<StytchWalletKey, Xpub>;

type StytchTrustedMetadata = {
  wallets: StytchBackupData;
};

export type TWalletsMap = Record<string, { walletId: string; xpub: string }[]>;

export const extractSavedKeys = (
  stytchWallets?: StytchTrustedMetadata["wallets"],
): TWalletsMap => {
  if (!stytchWallets) return {};
  const pubkeys = Object.entries(stytchWallets).reduce(
    (prev, [key, value]) => {
      const [algo, wid] = key.split(":");

      return {
        ...prev,
        [algo]: [
          ...(prev?.[algo] ? prev[algo] : []),
          { walletId: wid, xpub: value },
        ],
      };
    },
    {} as Record<string, { walletId: string; xpub: string }[]>,
  );

  return pubkeys;
};
